import React, { useEffect, useState } from 'react'
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper'
import { getNameClient } from '../../helpers/nameClient'
import {Container  } from "reactstrap";
import FormSteps from '../../components/Common/FormSteps/FormSteps';
import { useDispatch, useSelector } from 'react-redux';
import { CreateCargoRelease, getAdressByEntity, getCargoReleaseOptions } from '../../store/cargoReleaseCreation/actions';
import ItemAggregationCR from './ItemAggregationCR';
import Swal from 'sweetalert2';
import moment from 'moment';
import usePageTitle from '../../common/hooks/usePageTitle';
import { useHistory } from 'react-router';
const CrCreation = (props: any) => {

  const dispatch = useDispatch();
  const history = useHistory();

  const { BillingReleaseList, CarrierList,ReleaseList,CargoRelaseNumber,addressByEntity} = useSelector((state: any) => {
    return {
      BillingReleaseList: state.cargoReleaseCreation.BillingReleaseList,
      CarrierList: state.cargoReleaseCreation.CarrierList,
      ReleaseList: state.cargoReleaseCreation.ReleaseList,
      CargoRelaseNumber:state.cargoReleaseCreation.CargoRelaseNumber,
      addressByEntity: state.cargoReleaseCreation.addressByEntity,

    };
});


   const PageTitleIEN = usePageTitle(props.location.pathname);


    const [form,setForm] = useState<any>({createDate:moment(new Date()).format(),releaseDate:moment(new Date()).format(),releasedTo:"",billingClient:"",carrier:"",purchaseOrderNumber:"",trackingNumber:"",proNumber:"",driver:"",driverLicense:"",notes:"",items:[],number:"",street:"",city:"",state:"",zipCode:"",description:"",country:"",contactPhone:""})



    const handleItemsList = (item: any) => {
      const itemExists = form.items.some((existingItem: any) => existingItem.CLGUID === item.CLGUID);
      
      if (itemExists) {
        Swal.fire({
          text: `Item already added`,
          icon: 'warning', 
          confirmButtonText: 'Ok',
          customClass: {
            confirmButton: 'custom-confirm-button'
          }
        });
      } else {
        Swal.fire({
          text: `Do you want to add ${item.CLPartNumber}`,
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          reverseButtons: true,
          customClass: {
            confirmButton: 'custom-confirm-button',
            cancelButton: 'custom-cancel-button'
          },
        }).then((result) => {
          if (result.isConfirmed) {
            setForm((prevForm: any) => ({
              ...prevForm,
              items: [...prevForm.items, { ...item, pieces: 1 }]
            }));
          }
        });
      }
    };
    

    const DeleteItemsList = (GUID: any) => {
      setForm((prevForm:any) => ({
        ...prevForm,
        items: prevForm.items.filter((item: any) => item.CLGUID !== GUID)
      }));
    };

    const updateItemPieces = (GUIDItem:any, newPieces:any) => {
      setForm((prevForm:any) => ({
        ...prevForm,
        items: prevForm.items.map((item:any) => 
          item.CLGUID === GUIDItem 
            ? { ...item, pieces: newPieces } 
            : item
        ),
      }));
    };

    const newReleasedTo = (name:any,onPopUpState:any)=>{
      if(name){
          Swal.fire({
              title: 'Are you sure?',
              text: `You want to save "${name}" as Released to`,
              icon: 'info',
              showCancelButton: true, 
              confirmButtonText: 'Yes, save it!',
              cancelButtonText: 'No, cancel',
              reverseButtons: true,
              customClass: {
                  confirmButton: 'custom-confirm-button',
                  cancelButton: 'custom-cancel-button',
              },
            }).then((result:any) => {
              if (result.isConfirmed) {
                handleForm("releasedTo", name);
                
              if (onPopUpState) {
                  onPopUpState();
              }

              }
            });
      }
  }

  const list = [
    {
      "title": "General Information",
      "description": "Enter the general information for this cargo release such as the Number, Date and Release To.",
      "icon": "bx bx-book-bookmark",
      "files": [
        {
          "name": "Release date",
          "type": "date",
          "namekey": "releaseDate",
        //   "options": []
        },
        {
          "name": "Released to",
          "type": "select",
          "namekey": "releasedTo",
          "options": ReleaseList,
          "onClickButton": {label:"Add",actionOnClick:newReleasedTo,showButton:true}
        },
        {
          "name": "Number",
          "type": "text",
          "namekey": "number",
          "readOnly":true
        },
        {
          "name": "Billing client",
          "type": "select",
          "namekey": "billingClient",
          "options": BillingReleaseList
        },
        {
          "name": "Notes",
          "type": "text",
          "namekey": "notes"
        },
      ]
    },
    //--------------------------------------------page two-----------------------
    {
      "title": "Released to Address",
      "description": "Information for released to address",
      "icon": "bx bx-street-view",
      "files": [
        {
          "name": "Description",
          "type": "text",
          "namekey": "description"
        },
        {
            "name": "Street",
            "type": "text",
            "namekey": "street",
          },
        {
          "name": "City",
          "type": "text",
          "namekey": "city",
        },
        {
          "name": "State",
          "type": "text",
          "namekey": "state"
        },
        {
          "name": "ZipCode",
          "type": "text",
          "namekey": "zipCode"
        },
        {
          "name": "Country",
          "type": "text",
          "namekey": "country"
        },
        {
          "name": "Contact Phone",
          "type": "text",
          "namekey": "contactPhone"
        },
      ]
    },
    //------------------------------------tercera pag-------------------------------------------------
    {
      "title": "Carrier Information",
      "description": "Enter the carier information for this cargo release",
      "icon": "bx bx-id-card",
      "files": [
        {
            "name": "Carrier",
            "type": "select",
            "namekey": "carrier",
            "options": CarrierList
          },
        {
          "name": "Purchase Order Number",
          "type": "text",
          "namekey": "purchaseOrderNumber",
        },
        {
          "name": "Tracking number",
          "type": "text",
          "namekey": "trackingNumber"
        },
        {
          "name": "Pro number",
          "type": "text",
          "namekey": "proNumber"
        },
        {
          "name": "Driver",
          "type": "text",
          "namekey": "driver"
        },
        {
          "name": "Driver's license",
          "type": "text",
          "namekey": "driverLicense"
        },
      ]
    },
    {
      "title": "Item selection",
      "description": "Enter the elements of the cargo release",
      "icon": "bx bx-archive-in",
      "node": <ItemAggregationCR updateItemPieces={updateItemPieces} DeleteItemsList={DeleteItemsList} handleItemsList={handleItemsList} list={form.items}/>
    },
    
  ]

  useEffect(()=>{
    dispatch(getCargoReleaseOptions())
  },[])

  useEffect(()=>{
    handleForm("number",CargoRelaseNumber)
  },[CargoRelaseNumber])

  useEffect(()=>{
    if(form.releasedTo){
      dispatch(getAdressByEntity(form.releasedTo))
    }
  },[form.releasedTo])

  useEffect(()=>{
    if(addressByEntity){
      setForm({
        ...form,
        country: addressByEntity.address_Country,
        city: addressByEntity.address_City,
        street: addressByEntity.address_Street,
        state: addressByEntity.address_State,
        zipCode: addressByEntity.address_ZipCode,
        description:addressByEntity.address_Description,
        contactPhone: addressByEntity.address_ContactPhone

    })
    }
  },[addressByEntity])


  const handleForm = (nameKey:string,change:any)=>{
    setForm({
        ...form,
        [nameKey]:change
    })
  }

  const finishForm = () => {
    const { number, billingClient } = form;
  
    if (!billingClient) {
      Swal.fire({
        text: `Billing client is necessary`,
        icon: 'warning', 
        confirmButtonText: 'Ok',
      });
      return;
    }
  
    if (!number) {
      Swal.fire({
        text: `Number is necessary`,
        icon: 'warning', 
        confirmButtonText: 'Ok',
      });
      return;
    }
  
    dispatch(CreateCargoRelease({form:form,history:history}));
  };

  return (
    <React.Fragment>
            <div className="page-content">
                <PageTitle>
                    <title>Cargo Releace Creation | {getNameClient()}</title>
                </PageTitle>
                <Container fluid>  
                    <FormSteps
                        finishForm={finishForm}
                        form={form}
                        changeForm={handleForm}
                        items={list}
                        onCancel={() => history.push('/CRList')}
                    />
                </Container>
            </div>

            
        </React.Fragment>
  )
}

export default CrCreation